import React from 'react';
import { Box, Typography, Container, useTheme } from '@mui/material';
import { GradientText } from '../components/ui/GradientText';
import { MissionSection } from '../components/sections/MissionSection';
import { ResearchSection } from '../components/sections/ResearchSection';
import { ValuesSection } from '../components/sections/ValuesSection';
import { CTASection } from '../components/sections/CTASection';
import { ABOUT_CONTENT } from '../constants';

/**
 * About page
 * Contains hero, mission, research, values, and CTA sections
 */
export const AboutPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 5, md: 8 },
          background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <GradientText
            variant="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2.5rem', md: '3rem' },
            }}
          >
            {ABOUT_CONTENT.hero.title}
          </GradientText>

          <Typography
            variant="h5"
            color="text.secondary"
            sx={{
              fontWeight: 400,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            {ABOUT_CONTENT.hero.subtitle}
          </Typography>
        </Container>
      </Box>

      {/* Content Sections */}
      <MissionSection compact />
      <ResearchSection compact />
      <ValuesSection compact />
      <CTASection />
    </Box>
  );
};
